import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { Apiservice } from '../../../services/api.service';
import { alert } from 'devextreme/ui/dialog';
import { ITabCrm } from '../crm-tab-panel/crm-tab-panel.component';
import { Utenteservice } from '../../../services/utente.service';
import { IPartner } from '../../../views/crm/interfaces';


@Component({
  selector: 'app-crm-master-detail-contatti',
  templateUrl: './crmMasterDetailContatti.component.html',
  styleUrls: ['./crmMasterDetailContatti.component.css']
})
export class CrmMasterDetailContattiComponent implements OnInit, AfterViewInit {
  @Input() dataRelated: { [key: string]: any } = {}
  @Input() masterKey = ''
  @Input() queryString = ''
  tabDefinizione: ITabCrm[];
  isLoading = true
  public partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  };
  @Output() onAllEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  constructor(private utenteSerivce: Utenteservice, private cdf: ChangeDetectorRef) { }
  ngAfterViewInit(): void {
    this.isLoading = false
    this.cdf.detectChanges()
  }
  ngOnInit(): void {
    this.tabDefinizione = [{
      id: 0,
      icon: 'bi bi-disc-fill',
      text: 'Procedure',
      component: 'CrmDettagliProcedureContattiComponent',
      active: true,
      istancedData: {
        masterKey: 'Cod',
        queryString: this.queryString,
        dataRelated: this.dataRelated,
        detailVisible: true,
        collassabile: false,
        btnInfo: false,
        tooltipInfo: true,
        heightTree: 210,
        focusStateEnabled: true,
        loading: true,
        partnerData: this.partnerData
      }
    },
    ];
    if (!this.partnerData.isPartner) {
      this.tabDefinizione.push({
        id: 1,
        icon: 'bi bi-bookmark-fill',
        text: 'Diario Attività',
        component: 'CrmDiarioAttivitaComponent',
        active: true,
        istancedData: {
          modifica: !this.partnerData.isPartner,
          aggiungi: !this.partnerData.isPartner,
          elimina: !this.partnerData.isPartner,
          soloRicercaGlobale: true,
          ricerca: false,
          isAdvancedXlsExportAvailable: false,
          isExportDocxAvailable: false,
          isExportExcelAvailable: false,
          isExportPDFAvailable: false,
          dataContatto: this.dataRelated,
          gridHeight: "300",
          filter: '?CodContatto=' + this.dataRelated.Cod,
          costantValues: [{ key: 'CodContatto', value: this.dataRelated.Cod }],
          partnerData: this.partnerData

        }
      },)
    }
  }
  onAllEvent(event) {
    //    console.log(event)
    if (event.name === "formContentInitializzed") {
      if (event.formData.UtenteCheInserisce === null) {
        if (event.component.dataSet)
          event.component.dataSet.UtenteCheInserisce = this.utenteSerivce.InfoDatiUtenteConnesso.nomeCompleto || ''
        if (event.component.dataJson)
          event.component.dataJson.UtenteCheInserisce = this.utenteSerivce.InfoDatiUtenteConnesso.nomeCompleto || ''
      }
      if (event.formData.DataInserimento === null) {
        if (event.component.dataSet)
          event.component.dataSet.DataInserimento = new Date()
        if (event.component.dataJson)
          event.component.dataJson.DataInserimento = new Date()
      }
    }
    //this.onAllEventEmitter.emit(event)
  }
}


